export const GET_ALL_CUISINES = 'GET_ALL_CUISINES'